import type { NetlinkingBlock, Slug } from "@/modules/jobSearchPrefiltered/types"
import type { FunctionComponent } from "react"

import { NetlinkingBlockItem } from "@/modules/jobSearchPrefiltered/components/PrefilteredAside/NetlinkingBlock/NetlinkingBlockItem"

import styles from "./NetlinkingBlocks.module.css"

type AvailableSlugs = (Slug & {
  titleTranslation: string
})[]

export type NetlinkingBlocks = {
  type: NetlinkingBlock["type"]
  availableSlugs: AvailableSlugs
  netlinkingBlockLabel: string
  seeMoreLabel: string
}[]

type NetlinkingBlocksProps = {
  netlinkingBlocks: NetlinkingBlocks
}

export const NetlinkingBlocks: FunctionComponent<NetlinkingBlocksProps> = ({ netlinkingBlocks }) => {
  return (
    <>
      {netlinkingBlocks.map(netlinkingBlock => (
        <NetlinkingBlockItem
          key={netlinkingBlock.type}
          netlinkingBlockLabel={netlinkingBlock.netlinkingBlockLabel}
          availableSlugs={netlinkingBlock.availableSlugs}
          className={styles.block}
          seeMoreLabel={netlinkingBlock.seeMoreLabel}
        />
      ))}
    </>
  )
}
